import { render } from "./VesselsContent.vue?vue&type=template&id=a3ca2c6c&scoped=true"
import script from "./VesselsContent.vue?vue&type=script&lang=js"
export * from "./VesselsContent.vue?vue&type=script&lang=js"

import "./VesselsContent.vue?vue&type=style&index=0&id=a3ca2c6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3ca2c6c"]])

export default __exports__